import React from 'react';
import { Map } from 'immutable';
import { Row, Col } from 'bootstrap';
import { colors as Colors } from '@shoflo-rundown/cuesheet-data-helper';
import { HighlightColorOrder } from 'shared/components/pickers/colorPicker';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import ModalActions from 'flux/actions/ModalActions';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import classnames from 'classnames';
import PopoverActions from 'shared/flux/actions/PopoverActions';

export default {
  _getColorSelectorMenuItem(config) {
    const colorNodes = config.get('colorItems').map((item) => {
      return (
        <div
          key={'color-selector-' + item.get('color')}
          style={{ color: Colors[item.get('color')] }}
          className={'color-selector-option'}
        >
          <Icon name={item.get('icon')} onClick={item.get('onClick')} />
        </div>
      );
    });

    return (
      <Row className={'color-selector'}>
        <Col xs={1} className={'color-selector-icon'}>
          <Icon name={config.get('icon')} />
        </Col>
        <Col xs={18}>{colorNodes}</Col>
        <Col
          className={'color-selector-option icon-highlight-black'}
          xs={1}
          onClick={config.getIn(['showAllColors', 'onClick'])}
        >
          <Icon
            className={classnames({
              isColorGlobalActive: this.state.showAllGlobalColors,
              isColorPersonalActive: this.state.showAllPersonalColors,
            })}
            name={config.getIn(['showAllColors', 'icon'])}
          />
        </Col>
        <Col
          className={'color-selector-option icon-highlight-black'}
          xs={1}
          onClick={config.getIn(['removeColor', 'onClick'])}
        >
          <Icon name={config.getIn(['removeColor', 'icon'])} />
        </Col>
      </Row>
    );
  },

  _showAllGlobalColors() {
    this.setState({
      showAllGlobalColors: !this.state.showAllGlobalColors,
      showAllPersonalColors: false,
    });

    return this.state.showAllGlobalColors;
  },

  _showAllPersonalColors() {
    this.setState({
      showAllPersonalColors: !this.state.showAllPersonalColors,
      showAllGlobalColors: false,
    });

    return this.state.showAllPersonalColors;
  },

  getGlobalHighlightsNode(id) {
    const config = Map({
      icon: 'globe',
      colorItems: this._getColorItemsConfig(
        this._handleGlobalHighlight,
        this.state.showAllGlobalColors,
      ),
      showAllColors: Map({
        icon: 'angle-right',
        color: 'blue',
        onClick: (e) => {
          e.stopPropagation();
          this._showAllGlobalColors();
          PopoverActions.show(id);
        },
      }),
      removeColor: Map({
        icon: 'times-circle-o',
        color: 'black',
        onClick: (e) => {
          e.stopPropagation();
          this._handleGlobalHighlightRemove();
        },
      }),
    });

    return (
      <WithTooltip placement="right" tip={TooltipConstants.CSGlobalHighlight}>
        {this._getColorSelectorMenuItem(config)}
      </WithTooltip>
    );
  },

  getPersonalHighlightsNode(id) {
    const config = Map({
      icon: 'user',
      colorItems: this._getColorItemsConfig(
        this._handlePersonalHighlight,
        this.state.showAllPersonalColors,
      ),
      showAllColors: Map({
        icon: 'angle-right',
        color: 'blue',
        onClick: (e) => {
          e.stopPropagation();
          this._showAllPersonalColors();
          PopoverActions.show(id);
        },
      }),
      removeColor: Map({
        icon: 'times-circle-o',
        color: 'black',
        onClick: (e) => {
          this._handlePersonalHighlightRemove();
          e.stopPropagation();
        },
      }),
    });

    return (
      <WithTooltip placement="right" tip={TooltipConstants.CSPersonalHighlight}>
        {this._getColorSelectorMenuItem(config)}
      </WithTooltip>
    );
  },

  _getColorItemsConfig(onClick, showAllColors) {
    let colorItems = HighlightColorOrder.map((color) => {
      return Map({
        icon: 'circle',
        color,
        onClick: (e) => {
          e.stopPropagation();
          onClick(color);
        },
      });
    });

    if (!showAllColors) {
      colorItems = colorItems.splice(0, 9);
    }

    return colorItems;
  },

  _handlePersonalHighlight(color) {
    this._hideModalOrPopover();
    CuesheetRowActions.updateRowPersonalHighlight(
      this._getRowIndex(),
      'highlight-' + color,
    );
  },

  _handlePersonalHighlightRemove() {
    this._hideModalOrPopover();
    CuesheetRowActions.updateRowPersonalHighlight(
      this._getRowIndex(),
      'highlight-none',
    );
  },

  _handleGlobalHighlight(color) {
    this._hideModalOrPopover();
    CuesheetRowActions.updateRowHighlight(
      this._getRowIndex(),
      'highlight-' + color,
    );
  },

  _handleGlobalHighlightRemove() {
    this._hideModalOrPopover();
    CuesheetRowActions.updateRowHighlight(
      this._getRowIndex(),
      'highlight-none',
    );
  },

  _getRowIndex() {
    if (typeof this.props.rowIndex === 'number') return this.props.rowIndex;
    return this.state.rowIndex;
  },

  _hideModalOrPopover() {
    if (this._getModalId) {
      ModalActions.hide(this._getModalId());
    } else if (this.state.popoverVisibility) {
      //TODO..`
    }
  },
};
